export enum StatusType {
    'NEW' = 'status_new',
    'INPROGRESS' = 'status_inprogress',
    'COMPLETED' = 'status_completed',
    'COMPLETED_PLANNER' = 'status_completed_planner',
    'CANCELLED' = 'status_canceled'
}
